import { User } from "lucide-react";
import { useEffect } from "react";
import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";
import { usePOSContext } from "@/modules/pos/presentation/context/POSContext";

type SalespersonSelectorProps = {
  branchId: string | null;
};

/**
 * แสดงผู้ขายแบบ fixed เป็น user ที่ login อยู่ — ไม่ให้เลือกคนอื่น
 */
export function SalespersonSelector({ branchId }: SalespersonSelectorProps) {
  const { user: currentUser } = useAuthState();
  const { selection, setSelection } = usePOSContext();

  // ผูก salesperson เป็น user ที่ login เสมอ
  useEffect(() => {
    if (branchId && selection && currentUser?.id) {
      const name = currentUser.name ?? currentUser.email ?? "—";
      if (
        selection.salespersonId !== currentUser.id ||
        selection.salespersonName !== name
      ) {
        setSelection({
          ...selection,
          salespersonId: currentUser.id,
          salespersonName: name,
        });
      }
    }
  }, [branchId, selection, currentUser?.id, currentUser?.name, currentUser?.email, setSelection]);

  if (!branchId || !selection) {
    return null;
  }

  const displayName =
    currentUser?.name ?? currentUser?.email ?? "—";

  return (
    <div className="flex items-center gap-2">
      <User className="h-4 w-4 shrink-0 text-muted-foreground" />
      <span className="font-medium text-foreground text-sm">
        {displayName}
      </span>
    </div>
  );
}
